$( function() {
    $( ".machine-type-accordion" ).accordion({
        heightStyle: "content"
        // collapsible: true
    });
} );